interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0a0a0f]/95 backdrop-blur-lg shadow-lg shadow-violet-500/5' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/ac6eabdb4cc8c584e68459ed2e8db63e/511f79aa6cb452487d1b4ad399421a46.png" 
              alt="AI Exécutif Assistant" 
              className="w-12 h-12 object-contain"
            />
            <span className="text-lg font-semibold bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent whitespace-nowrap">AI EXÉCUTIF ASSISTANT</span>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a href="#solution" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Solution</a>
            <a href="#fonctionnalites" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Fonctionnalités</a>
            <a href="#benefices" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Bénéfices</a>
            <a href="#cas-usage" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Cas d'usage</a>
            <a 
              href="https://calendly.com/contact-assistantexecutifai/30min?back=1&month=2026-01" 
              target="_blank" 
              rel="noopener noreferrer"
              className="px-6 py-2.5 bg-gradient-to-r from-violet-600 to-blue-600 rounded-lg text-sm font-medium hover:shadow-lg hover:shadow-violet-500/30 transition-all whitespace-nowrap cursor-pointer"
            >
              Réserver une consultation
            </a>
          </div>

          <button className="md:hidden text-white cursor-pointer">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}